import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AuthorizationScheme,
  ExternalIntegration,
  MutationExternalIntegrationCreateArgs,
  MutationExternalIntegrationDeleteArgs,
  WebhooksIntegration,
  WebhooksIntegrationInput,
} from "types/generated";

type FetchAccountExternalIntegrationsData = {
  externalIntegration: Omit<ExternalIntegration, "customConfig" | "deleted">;
  authorizationScheme: AuthorizationScheme;
};

export const GET_ACCOUNT_EXTERNAL_INTEGRATIONS: TypedDocumentNode<FetchAccountExternalIntegrationsData> = gql`
  query GetAccountExternalIntegrations {
    externalIntegrations {
      id
      name
      type
      createdAt
      deleted
      description
      spaceDetails {
        id
        name
        accessLevel
      }
      attachedBlueprints {
        id
      }
      apiKey {
        id
        name
      }
      customConfig {
        __typename
        ... on ExternalIntegrationConfigServiceNow {
          baseURL
          username
        }
      }
    }
    authorizationScheme
  }
`;

type FetchExternalIntegrationData = {
  externalIntegrationDelete: Pick<ExternalIntegration, "id" | "name">;
};

export const DELETE_EXTERNAL_INTEGRATION: TypedDocumentNode<
  FetchExternalIntegrationData,
  MutationExternalIntegrationDeleteArgs
> = gql`
  mutation DeleteExternalIntegration($id: ID!) {
    externalIntegrationDelete(id: $id) {
      id
      name
    }
  }
`;

type CreateExternalIntegrationResponse = {
  externalIntegrationCreate: Pick<ExternalIntegration, "id">;
};

type CreateExternalIntegrationWithSecretResponse = {
  externalIntegrationCreate: Pick<ExternalIntegration, "id" | "apiKey" | "name">;
};

export const CREATE_EXTERNAL_INTEGRATION: TypedDocumentNode<
  CreateExternalIntegrationResponse,
  MutationExternalIntegrationCreateArgs
> = gql`
  mutation CreateExternalIntegration($input: ExternalIntegrationInput!) {
    externalIntegrationCreate(input: $input) {
      id
    }
  }
`;

export const CREATE_EXTERNAL_INTEGRATION_WITH_SECRET: TypedDocumentNode<
  CreateExternalIntegrationWithSecretResponse,
  MutationExternalIntegrationCreateArgs
> = gql`
  mutation CreateExternalIntegrationWithSecret($input: ExternalIntegrationInput!) {
    externalIntegrationCreate(input: $input) {
      id
      name
      apiKey {
        id
        secret
      }
    }
  }
`;

type UpdateWebhookIntegrationData = {
  webhooksIntegrationUpdate: Pick<WebhooksIntegration, "id">;
};

type UpdateWebhookIntegrationVariables = {
  id: string;
  moduleId: string;
  input: WebhooksIntegrationInput;
};

// This is just placeholder, the actual query is not provided
export const UPDATE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  UpdateWebhookIntegrationData,
  UpdateWebhookIntegrationVariables
> = gql`
  mutation UpdateWebhookIntegrationForModule(
    $id: ID!
    $moduleId: ID!
    $input: WebhooksIntegrationInput!
  ) {
    webhooksIntegrationUpdate(id: $id, stack: $moduleId, input: $input) {
      id
    }
  }
`;
